/* Inelia Books — tasteful motion.
   Progressive enhancement: elements are only hidden once JS runs, so with
   JS off (or reduced motion) everything is visible and static. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---------------------------------------------------- */
  if (!reduce && 'IntersectionObserver' in window) {
    var SELECTORS = [
      '.ib-section-head',
      '.ib-coll-head',
      '.ib-card',
      '.ib-shelf-card',
      '.ib-entry-card',
      '.ib-guide-card',
      '.ib-cs-card',
      '.ib-featured',
      '.ib-hero__inner > *',
      '.ib-author',
      '.ib-bio',
      '.ib-notify__grid > *',
      '.ib-contact > *',
      '.ib-product__media',
      '.ib-product__info',
      '.ib-view-all',
      '.ib-newsletter .ib-wrap > *'
    ];

    var nodes = [];
    SELECTORS.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
        if (nodes.indexOf(el) === -1) nodes.push(el);
      });
    });

    // Stagger siblings that share a parent for a gentle cascade.
    var seen = new Map();
    nodes.forEach(function (el) {
      el.classList.add('ib-reveal');
      var parent = el.parentNode;
      var i = seen.get(parent) || 0;
      var delay = Math.min(i * 70, 420);
      if (delay) el.style.transitionDelay = delay + 'ms';
      seen.set(parent, i + 1);
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ib-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    var vh = window.innerHeight || document.documentElement.clientHeight;
    nodes.forEach(function (el) {
      var top = el.getBoundingClientRect().top;
      if (top < vh * 0.92) {
        // Above the fold — reveal on the next frame so it animates in on load.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { el.classList.add('ib-in'); });
        });
      } else {
        io.observe(el);
      }
    });
  }

  /* ---- Header lift on scroll -------------------------------------------- */
  var header = document.querySelector('.ib-header-wrap--sticky');
  if (header) {
    var onScroll = function () {
      if (window.pageYOffset > 12) header.classList.add('ib-scrolled');
      else header.classList.remove('ib-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
